var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-check"},[_c('img',{attrs:{"src":require("@/assets/images/voicemod-loader.gif")}}),_c('div',{staticClass:"payment-check__text"},[_vm._v(" "+_vm._s(_vm.$t('checkout.checking-purchase'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }